<template>
  <svg :style="iconStyle" :viewBox="viewBox" :height="calculatedIconHeight" :width="calculatedIconWidth" class="icon">
    <title v-if="iconTitle">{{iconTitle}}</title>
    <desc v-if="iconDescription">{{iconDescription}}</desc>
    <use :xlink:href="iconId">
    </use>
  </svg>
</template>
<script>
  export default {
    props: {
      iconStyle: {
        type: Object,
        default: () => {}
      },
      iconDescription: {
        type: String,
        default: ""
      },
      iconHeight: {
        type: String,
        default: "1rem"
      },
      iconName: {
        type: String,
        required: true
      },
      iconWidth: {
        type: String,
        default: "1rem"
      },
      iconTitle: {
        type: String,
        default: ""
      },
      viewBox: {
        type: String,
        required: true,
      }
    },
    data() {
      return {
        icon: ""
      }
    },
    computed: {
      calculatedIconHeight() {
        return this.viewBox.split(" ")[3] || this.iconHeight
      },
      calculatedIconWidth() {
        return this.viewBox.split(" ")[2] || this.iconWidth
      },
      iconId() {
        return `#${this.icon.id}`
      }
    },
    beforeMount() {
      this.setIcon();
    },
    watch: {
      iconName() {
        this.setIcon();
      }
    },
    methods: {
      async setIcon() {
        const icon = await import(`!!svg-sprite-loader!../assets/icons/${this.iconName}.svg`);
        this.icon = icon.default;
      }
    }
  }
</script>
